import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large CategoriesActions",
    title: _ctx.modalTitle,
    "confirm-button-text": _ctx.modalConfirmButtonText,
    "confirm-button-class": _ctx.isDelete ? 'medium red' : undefined,
    "confirm-message": `Вы действительно хотите удалить категорию?`,
    "is-confirm": _ctx.isDelete,
    loading: _ctx.loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitManager
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_input, {
        value: _ctx.state.name,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.name) = $event)),
        "is-invalid": _ctx.state_form$.name.$error,
        "validation-errors": _ctx.state_form$.name.$errors,
        placeholder: "Название категории"
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        class: "mt-2",
        value: _ctx.state.volume,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.volume) = $event)),
        "is-invalid": _ctx.state_form$.volume.$error,
        "validation-errors": _ctx.state_form$.volume.$errors,
        placeholder: "Объем"
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        class: "mt-2",
        value: _ctx.state.capacity,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.capacity) = $event)),
        "is-invalid": _ctx.state_form$.capacity.$error,
        "validation-errors": _ctx.state_form$.capacity.$errors,
        placeholder: "Вместимость"
      }, null, 8, ["value", "is-invalid", "validation-errors"])
    ]),
    _: 1
  }, 8, ["title", "confirm-button-text", "confirm-button-class", "is-confirm", "loading", "onCancel", "onConfirm"]))
}